import { speakingConfig } from '../config/speakingConfig';

export const getPartConfig = (partNumber) => {
  const partKey = `part-${partNumber}`;
  return speakingConfig.parts[partKey] || null;
};

export const hasPreInstructions = (partNumber) => {
  const config = getPartConfig(partNumber);
  return config && config.preInstructions && config.preInstructions.length > 0;
};

export const hasPostInstructions = (partNumber) => {
  const config = getPartConfig(partNumber);
  return config && config.postInstructions && config.postInstructions.length > 0;
};

export const getWaitingTime = (partNumber) => {
  const config = getPartConfig(partNumber);
  return config?.waitingTime || 5;
};

export const getRecordingLimit = () => {
  return speakingConfig.global.recordingTimeLimit || 'no-limit';
};

export const getPreInstructions = (partNumber) => {
  const config = getPartConfig(partNumber);
  return config?.preInstructions || [];
};

export const getPostInstructions = (partNumber) => {
  const config = getPartConfig(partNumber);
  return config?.postInstructions || [];
};

export const shouldShowPrePartInstructions = () => {
  return speakingConfig.global.showPrePartInstructions !== false;
};

export const shouldShowPostPartInstructions = () => {
  return speakingConfig.global.showPostPartInstructions === true;
};
